import { useContext } from 'react';
import { KeysContext } from '../contexts/KeysContext';
import { KeysContextType } from '../contexts/KeysContextTypes';

export const useKeysContext = (): KeysContextType => {
  const context = useContext(KeysContext);
  
  if (context === undefined) {
    throw new Error('useKeysContext must be used within a KeysProvider');
  }
  
  return context;
};